import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { FormsModule } from '@angular/forms';

import {FieldModule as FormFieldModule} from '@appkit4/angular-components/field';
import {DropdownModule} from '@appkit4/angular-components/dropdown';
import {DropdownListItemModule} from '@appkit4/angular-components/dropdown-list-item';
import {TableModule} from '@appkit4/angular-components/table';
import {CheckboxModule} from '@appkit4/angular-components/checkbox';
import {SearchModule} from '@appkit4/angular-components/search';
import {ButtonModule} from '@appkit4/angular-components/button';
import {LoadingModule} from '@appkit4/angular-components/loading';
import {ListModule} from '@appkit4/angular-components/list';
import {PanelModule as PanelsCardsModule} from '@appkit4/angular-components/panel';
import {RadioModule as RadiobuttonModule} from '@appkit4/angular-components/radio';
import {TabsModule as TabModule} from '@appkit4/angular-components/tabs';
import {ModalModule} from '@appkit4/angular-components/modal';
import {TooltipModule} from '@appkit4/angular-components/tooltip';
import {NotificationModule as AlertModule} from '@appkit4/angular-components/notification';
import {DatepickerModule as DatePickerModule} from '@appkit4/angular-components/datepicker';
import {FileuploaderModule} from '@appkit4/angular-components/fileupload';
import {ToggleModule} from '@appkit4/angular-components/toggle';
import { AccordionModule as AccordionsModule } from '@appkit4/angular-components/accordion';
import { BadgeModule } from '@appkit4/angular-components/badge';
import {HeaderModule} from '@appkit4/angular-components/header';
import {NavigationModule} from '@appkit4/angular-components/navigation';
import {FooterModule} from '@appkit4/angular-components/footer';
import {PaginationModule} from '@appkit4/angular-components/pagination';
import {TreeModule} from '@appkit4/angular-components/tree';
import {BreadcrumbModule} from '@appkit4/angular-components/breadcrumb';
import {AvatarModule} from '@appkit4/angular-components/avatar';
import {ProgressModule} from '@appkit4/angular-components/progress';
import {FilterModule} from '@appkit4/angular-components/filter';
import {TextEditorModule} from '@appkit4/angular-text-editor/text-editor';
import { AppkitDropdownEmptyStateDirective } from './shared/directives/appkit-dropdown-empty-state.directive';
import { AppkitDropdownOverlayClickDirective } from './shared/directives/appkit-dropdown-overlay-click.directive';
import { AppkitDropdownSearchFilterDirective } from './shared/directives/appkit-dropdown-search-filter.directive';
import { AppkitDropdownNoScrollOnOpenDirective } from './shared/directives/appkit-dropdown-no-scroll-on-open.directive';

const APPKIT_DIRECTIVES = [
  AppkitDropdownEmptyStateDirective,
  AppkitDropdownOverlayClickDirective,
  AppkitDropdownSearchFilterDirective,
  AppkitDropdownNoScrollOnOpenDirective,
];

const APPKIT_MODULES = [
  FormFieldModule,
  DropdownModule,
  DropdownListItemModule,
  TableModule,
  CheckboxModule,
  TabModule,
  ModalModule,
  ButtonModule,
  SearchModule,
  AlertModule,
  LoadingModule,
  ListModule,
  DatePickerModule,
  TooltipModule,
  FileuploaderModule,
  PanelsCardsModule,
  RadiobuttonModule,
  ToggleModule,
  AccordionsModule,
  BadgeModule,
  HeaderModule,
  NavigationModule,
  FooterModule,
  PaginationModule,
  TreeModule,
  BreadcrumbModule,
  AvatarModule,
  ProgressModule,
  FilterModule,
  TextEditorModule,
];

@NgModule({
  declarations: [...APPKIT_DIRECTIVES],
  imports: [
    CommonModule,
    FormsModule,
    ...APPKIT_MODULES,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ...APPKIT_MODULES,
    ...APPKIT_DIRECTIVES,
  ]
})
export class AppNgAppkitModule {}
